import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {
	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/list", params, successCallback, failCallback, exceptionCallback);
	},
	save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/save", params, successCallback, failCallback, exceptionCallback);
	},
	toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},getBySBLIDandSurRecordID: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/getBySBLIDandSurRecordID", params, successCallback, failCallback, exceptionCallback);
	},
	update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/update", params, successCallback, failCallback, exceptionCallback);
	},
	remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/remove", params, successCallback, failCallback, exceptionCallback);
	},
	listSprBl:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/sprint/sprintBacklog/list", params, successCallback, failCallback, exceptionCallback);
	},
	uploadImg:(params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/surveyRecord/surveyRecord/uploadImg", params, successCallback, failCallback, exceptionCallback);
	},
}

export default api;
